
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39 19.64v8.64c0 .19-.079.374-.22.51a.766.766 0 01-.53.21H33a.766.766 0 01-.53-.21.706.706 0 01-.22-.51V23.6a.353.353 0 00-.11-.255.383.383 0 00-.265-.105h-3.75c-.1 0-.195.038-.265.105a.353.353 0 00-.11.255v4.68c0 .19-.079.374-.22.51A.766.766 0 0127 29h-5.25a.766.766 0 01-.53-.21.706.706 0 01-.22-.51v-8.64c0-.382.158-.748.44-1.018l7.5-7.2c.281-.27.662-.422 1.06-.422s.779.152 1.06.421l7.5 7.2c.282.27.44.637.44 1.019z","fill":"#fff"}})])
          )
        }
      }
    